import BaseModel from '../core/BaseModel'
export default class TypeViolationModel extends BaseModel {
    constructor() {
        super({ 
                name: "type_violation",
                tableName: 'core_type_violation'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            code: { 
                name: 'code', 
                type: "String", 
                label: 'Mã loại sự cố',
                primaryKey: true,
                filter: { type: 'input', match: 'contains'},
                width: 15,
                sortable: true
            },
           name: { 
                name: 'name', 
                type: "String", 
                label: 'Loại sự cố',
                filter: { type: 'input',match: 'custom'},
                sortable: true
            },
            ordering: { 
                name: 'ordering', 
                type: "String", 
                label: 'Thứ tự hiển thị',
                class: 'center',
                width: 12
            },
            status: {
                name: 'status', label: 'Hiển thị sử dụng', type: "Selection", dataType: 'Label', class: 'center disabled-opacity', width: 15, disabled: true,
                options: [{ value: 1, label: 'Có'}, { value: 0, label: 'Không'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
            }
        },)
    }

}